var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChatQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1c6.617 0 12 4.244 12 9.461 0 5.175-5.21 9.4-11.68 9.536L12 20h-1.436c-1.91 2.779-6.138 2.987-6.518 3H4a1.003 1.003 0 01-.782-1.624c.016-.02 1.437-1.828 1.719-3.72C2.446 16.409 0 13.774 0 10.461 0 5.244 5.383 1 12 1zm0 2C6.486 3 2 6.347 2 10.461c0 2.563 2.191 4.778 4.355 5.642.38.151.629.519.629.928 0 1.327-.472 2.625-.98 3.636 1.156-.317 2.492-.933 3.107-2.126a1 1 0 01.766-.533L10 18h2c5.514 0 10-3.382 10-7.539C22 6.347 17.514 3 12 3zm.71 11.29c.18.19.29.45.29.71 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.38-.37 1.05-.37 1.42 0zM12 6c1.654 0 3 1.346 3 3a2.99 2.99 0 01-1.828 2.748l-.172.067V12a.97.97 0 01-.179.538l-.07.118a.388.388 0 01-.041.054c-.051.048-.116.076-.176.114A.973.973 0 0112 13a.976.976 0 01-.532-.175c-.06-.038-.127-.066-.178-.115-.048-.051-.076-.116-.114-.176a1.04 1.04 0 01-.167-.416L11 12v-1a1 1 0 011-1c.551 0 1-.449 1-1 0-.551-.449-1-1-1-.551 0-1 .449-1 1a1 1 0 01-2 0c0-1.654 1.346-3 3-3z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconChatQuestion;